/* global translate */ 
import React from 'react' 

const RxSearchBox = global.rootRequire('components/shares/rxSearchBox').default
const RxModalEdit = global.rootRequire('components/shares/rxModalEdit').default

const { rxaget, autoConvertTime, rxChangeSlug, stringToColour ,changeColorSVG} = global.rootRequire('classes/ulti')

export const renderBody = (vm) => {
  return (
    <div>
      {(!vm.state.groupsSearchBoxClickStatus) && <div className='zleft_searchwrap'>
        <div className='icon_basic_search_area'>
          <img className='icon_basic_search filter_img_class'  src={changeColorSVG('./images/default/icons/search-active.svg')} alt=''/>
        </div>

        <input type='search' maxLength='30' placeholder={translate('Search')} className={rxaget(vm.props, 'themeBackgroudValue') === 'darkTheme' ? 'zleft_search_place darkThemeInput':'zleft_search_place lightThemeInput'}  onClick={e => {vm.groupsSearchBoxClick()}}></input>

        <div className='dropdown'>
          <div className='zleft_edit'>
            <img className='icon32 filter_img_class' src={changeColorSVG('./images/default/icons/edit.svg')} alt=''/>
            <img className='icon32_white' src={changeColorSVG('./images/default/icons/edit40x40.svg')} alt=''/>
          </div>
          { <div className='dropdown-content'>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item' onClick={e => { vm.createNewChatGroup('create_chat') }} >
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-user.svg')} alt=''/>
                  <span className='new_chat'>
                    {translate('New Message')}
                  </span>
                </div>
              </div>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item channel'  onClick={e => { vm.createNewChatGroup('create_group')}} >
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-group.svg')} alt=''/>
                  <span className='new_chat'>
                    {translate('New Group Chat')}
                  </span>
                </div>
              </div>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item channel'  onClick={e => { vm.createNewChatGroup('create_channel') }} >
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-channel.svg')} alt=''/>
                  <span className='new_chat'>
                    {translate('New Channel')}
                  </span>
                </div>
              </div>
            </div>
          }
        </div>

      </div>} 
      {(vm.state.groupsSearchBoxClickStatus) &&
        <div className='zleft_search_container' style={{height: vm.state.windowHeight}}>
          <div className='rxsearch-wrapper-hidden' onClick={e => {vm.groupsSearchBoxClick()}}></div>
          <RxSearchBox 
            searchBoxvalue = {(clickStatus,searchValue)=>{vm.getSearchBoxvalue(clickStatus,searchValue)}}
            pageActive = {'chatPage'}        
            searchBox_chooseGroup = {(group)=>{vm.searchBox_chooseGroup(group)}}
            createNewChatGroup = {(type_popup) => vm.createNewChatGroup(type_popup)}        
            chooseContact = {()=>vm.chooseContact()}
            onClickAddContact ={(ele)=>vm.onClickAddContact(ele)}
            groupsSearchBoxClick = {() => vm.groupsSearchBoxClick()}
            groupsSearchBoxClickStatus = { vm.state.groupsSearchBoxClickStatus }
            groups = {vm.state.groups}
            groupsNChatOrigin = {vm.state.groupsNChatOrigin}
          />
        </div>}
        
        {(vm.state.displayAddContact === true) && 
          <RxModalEdit 
            onClickModalEdit = {() => {vm.setState({displayAddContact:false, flagEdit: false, contactInfo: {}})}}
            onSubmitContact = {(ele) => vm.onSubmitContact(ele)}
            flagEdit = {vm.state.flagEdit}
            contactInfo = {vm.state.contactInfo}
        />}
        
    </div>
  )
}

export const renderComponent = (vm) => <div>
  {vm.renderBody()}
</div>

